import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9f7840f2&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9f7840f2&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=9f7840f2&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7840f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f7840f2')) {
      api.createRecord('9f7840f2', component.options)
    } else {
      api.reload('9f7840f2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9f7840f2&scoped=true&lang=pug", function () {
      api.rerender('9f7840f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/contracts/agreeLearnRule/index.vue"
export default component.exports